import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import fondo from '../../assets/img/landingPage/fondo.png';
import dashboard from '../../assets/img/landingPage/designer/dashboard_APIDesign01.png'

import features_1 from '../../assets/img/landingPage/designer/Feature_APIDesign01.png'
import features_2 from '../../assets/img/landingPage/designer/Feature_APIDesign02.png'
import features_3 from '../../assets/img/landingPage/designer/Feature_APIDesign03.png'

import icon_1 from '../../assets/img/landingPage/designer/icn_Designer-01.png'
import icon_2 from '../../assets/img/landingPage/designer/icn_Desginer-02.png'
import icon_3 from '../../assets/img/landingPage/designer/icn_Designer-03.png'

import logo from '../../assets/img/logos/AVAP_APIDesigner-negativo.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const APIDesignerProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroSolutions" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP API Designer"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Design Smarter APIs, Effortlessly</h1>
                    <p className="fl-subtitle">
                    Model APIs with OAS or A2ML in an intuitive, modular environment
                    </p>
                   {/*<a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>*/}
                   <img
                        src={dashboard}
                        alt=" Modern API Design with OAS and A2ML (AVAP API Modeling Language) 
                        for Scalable Architecture"
                        className="img-fluid mt-4"
                        style={{ 
                            width: '70%', 
                            maxWidth: '700px', 
                            height: 'auto' ,
                            paddingTop: "100px" }}
                    />      
                    
                </section>

                {/* Powerful API Platform */}
                <section id= "subtitleSection" className="text-center pb-5">
                    
                    <p className="fl-subtitle mb-3 fl-txt-container-s">
                         Modern API Design with OAS and A2ML (AVAP API Modeling Language) 
                         for Scalable Architecture

                    </p>
                    <p className="fl-text fl-txt-container-s">
                            AVAP API Design is the visual-first, specification-based API modeling tool of AVAP Framework. It empowers developers and architects to design, document, and iterate APIs using both OpenAPI Specification (OAS) and A2ML - AVAP’s proprietary modeling language that extends OAS with support for fragmentation and modularity. 
                            Whether you’re starting from scratch or editing existing assets, AVAP API Design provides an intuitive interface, real-time validation, and seamless integration with the full AVAP lifecycle.


                    </p>
                </section>

                {/* Features */}
                            <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_1} alt="icon_1" />
                                <p>Supports OAS and A2ML</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_2} alt="icon_2" />
                                <p>Modular API Definition</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_3} alt="icon_3" />
                                <p>Integrated with AVAP Development</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Dual-Spec API Modeling</h3>
                            <p className="fl-text">
                            Design Virtual APIs using the globally adopted OpenAPI Specification or take advantage of A2ML (AVAP API Modeling Language), which allows for cleaner, modular, and more maintainable API structures.                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Visual & Code-First Design</h3>
                            <p className="fl-text">
                            Effortlessly switch between a visual interface and code editor while maintaining API structure integrity. Real-time previews and validations help you catch errors early, streamline your workflow, and ensure your API design is accurate and consistent from start to finish.


                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>



                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Fragmentation & Reusability with A2ML
                            </h3>
                            <p className="fl-text">
                            Leverage the power of A2ML (AVAP API Modeling Language) to break your API definitions into independent, reusable fragments. This approach enables faster development cycles, promotes consistency across multiple services, and simplifies governance by allowing centralized updates to shared API components.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Scalable Design for Complex Architectures

                                </p>
                                <p className="fl-text">
                                Model APIs for microservices or enterprise systems with a framework built for long-term scalability and modularity.
                                    <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Faster Development with Reusable Components
                                </p>
                                <p className="fl-text">
                                With A2ML’s fragmentation, teams can reuse components, reduce duplication, and accelerate the design-to-deploy process.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Built for AVAP Framework
                                </p>
                                <p className="fl-text">
                                Enjoy native compatibility with AVAP’s full suite, from versioning to publishing, for a seamless development lifecycle.

                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default APIDesignerProduct;
